import * as Sentry from '@sentry/react';

// Errors to ignore - typically third-party errors we can't fix
const IGNORED_ERRORS = [
  '[KEA] Can not find path', // PostHog toolbar internal errors
];

// Backends that should receive sentry-trace/baggage headers, so browser
// transactions and the API transactions they trigger end up in one trace.
// Production hosts only — the SDK is disabled outside production anyway.
const TRACE_PROPAGATION_TARGETS = [
  /^https:\/\/(www\.|app\.)?ritabygglov\.se/,
  /^https:\/\/(www\.|app\.)?drawblueprint\.com/,
];

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://3a6869074b91033356ec004b2770502d@o4505727220645888.ingest.us.sentry.io/4509340231925760',
    // Disable PII collection (IP addresses, etc.) for privacy compliance
    sendDefaultPii: false,
    enabled: import.meta.env.MODE === 'production',
    _experiments: { enableLogs: true },
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 1.0
    ),
    tracePropagationTargets: TRACE_PROPAGATION_TARGETS,
    beforeSend(event) {
      // Gather all possible error messages to check
      const exceptionValues = event.exception?.values || [];
      const messagesToCheck = [
        ...exceptionValues.map((ex) => ex.value || ''),
        event.message || '',
      ];

      // Check if any error message matches any ignored pattern
      if (
        messagesToCheck.some((msg) =>
          IGNORED_ERRORS.some((pattern) => msg.includes(pattern))
        )
      ) {
        return null;
      }

      return event;
    },
  });
};
